module.exports = __webpack_public_path__ + "img/clipboard-download.61b1acbe.svg";